import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/PageHeader.css';

interface Props {
    title: string;
    titleContent?: React.ReactNode;
    breadcrumbs?: { label: string; onClick: () => void }[];
    onBack?: () => void;
    actions?: React.ReactNode;
    secondary?: React.ReactNode;
}

/** Shared desktop/web navigation, with browser-native links and controls. */
const PageHeader = React.forwardRef<HTMLElement, Props>(({ title, titleContent, breadcrumbs = [], onBack, actions, secondary }, ref) => {
    const { t } = useTranslation();
    return <header className="app-page-header" ref={ref}>
        <div className="app-page-header__row">
            {onBack && <button type="button" className="app-page-header__back" onClick={onBack} aria-label={t('common.back')} title={t('common.back')}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6" /></svg>
            </button>}
            <nav className="app-page-header__navigation" aria-label={t('common.breadcrumbs')}>
                <ol className="app-page-header__breadcrumbs">
                    {breadcrumbs.map((crumb, index) => <li className="app-page-header__ancestor" key={index}>
                        <button type="button" onClick={crumb.onClick} title={crumb.label}>{crumb.label}</button><span aria-hidden="true">/</span>
                    </li>)}
                    <li className="app-page-header__current" aria-current="page">{titleContent ?? <h1 title={title}>{title}</h1>}</li>
                </ol>
            </nav>
            {actions && <div className="app-page-header__actions">{actions}</div>}
        </div>
        {secondary && <div className="app-page-header__secondary">{secondary}</div>}
    </header>;
});

export default PageHeader;
